import { render } from "./GridUsuario.vue?vue&type=template&id=f4954e30&ts=true"
import script from "./GridUsuario.vue?vue&type=script&lang=ts"
export * from "./GridUsuario.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__